// Effective payment environment, resolved server-side by BoardHelper::prepare()
// (sandbox host always wins over the funnel's system.environment flag).
export function isSandboxEnvironment() {
    if (typeof window === 'undefined') return false;
    return window.__BOARD_DATA__?.system?.environment === 'sandbox';
}
